var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.4 3.9V1.35C3.4 1.12457 3.48955 0.908365 3.64896 0.748959C3.80836 0.589553 4.02456 0.5 4.25 0.5H14.45C14.6754 0.5 14.8916 0.589553 15.051 0.748959C15.2104 0.908365 15.3 1.12457 15.3 1.35V13.25C15.3 13.4754 15.2104 13.6916 15.051 13.851C14.8916 14.0104 14.6754 14.1 14.45 14.1H11.9V16.65C11.9 17.1192 11.5175 17.5 11.044 17.5H0.855949C0.743857 17.5007 0.632737 17.4792 0.528974 17.4368C0.42521 17.3944 0.330848 17.3319 0.25131 17.2529C0.171771 17.1739 0.108624 17.08 0.0654961 16.9765C0.0223682 16.873 0.000109968 16.7621 0 16.65L0.00255002 4.75C0.00255002 4.2808 0.38505 3.9 0.858499 3.9H3.4ZM1.70255 5.6L1.7 15.8H10.2V5.6H1.70255ZM5.1 3.9H11.9V12.4H13.6V2.2H5.1V3.9Z",
    fill: "#63658E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5fa4367d0ef8c96d927911a732097998.svg";
export { ForwardRef as ReactComponent };